import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterWrapper = styled.footer`
  background-color: var(--color-secondary);
  color: white;
  margin-top: auto;
  padding: var(--spacing-16) 0 var(--spacing-8);
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--spacing-8);
  margin-bottom: var(--spacing-8);
`;

const FooterSection = styled.div`
  h3 {
    font-size: var(--font-size-lg);
    font-weight: 600;
    margin-bottom: var(--spacing-4);
    color: var(--color-primary);
  }
  
  p, a {
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.6;
    text-decoration: none;
    display: block;
    margin-bottom: var(--spacing-2);
  }
  
  a:hover {
    color: white;
  }
`;

const SocialLinks = styled.div`
  margin-top: var(--spacing-4);
  display: flex;
  gap: var(--spacing-3);
`;

const SocialButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    color: white;
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: var(--spacing-4);
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: var(--font-size-sm);

  a {
    color: rgba(255, 255, 255, 0.85);
    text-decoration: underline;
  }

  a:hover {
    color: white;
  }
`;

const Footer: React.FC = () => {
  return (
    <FooterWrapper>
      <div className="container">
        <FooterContent>
          <FooterSection>
            <h3>Om Lillaflora</h3>
            <p>
              En webshop från din mysiga lilla blomsterbutik med inredningsdetaljer 
              i Lilla Kramfors i Höga kusten. Vi skapar stämning och mys i ditt hem 
              med handplocka produkter från ljus till vackra koppar.
            </p>
          </FooterSection>
          
          <FooterSection>
            <h3>Kundservice</h3>
            <Link to="/kontakt">Kontakta oss</Link>
            <Link to="/leverans-retur">Leverans & Retur</Link>
            <Link to="/faq">Vanliga frågor</Link>
            <Link to="/floristbloggen">Floristbloggen</Link>
          </FooterSection>
          
          <FooterSection>
            <h3>Produkter & SEO</h3>
            <Link to="/produkter">Alla produkter</Link>
            <Link to="/produkter?kategori=doftljus-och-doftpinnar">Ljus & Doftljus</Link>
            <Link to="/produkter?kategori=dukning-och-servering">Dukning & servering</Link>
            <Link to="/produkter?kategori=textiler">Textilier & mjuka detaljer</Link>
            <Link to="/produkter?kategori=lyxigt-godis-och-annat">Lyxigt godis & presenttips</Link>
            <Link to="/kollektion/premium-inredning">Kollektion: Premium inredning</Link>
            <Link to="/kollektion/svenska-favoriter">Kollektion: Svenska favoriter</Link>
            <Link to="/kollektion/mysiga-hem">Kollektion: Mysiga hem</Link>
            <Link to="/kategori/doftljus-och-doftpinnar">SEO-kategori: Doftljus</Link>
          </FooterSection>
          
          <FooterSection>
            <h3>Kontakt</h3>
            <p>📧 butik@lillaflora.nu</p>
            <p>📞 0708555052</p>
            <p>📍 Torggatan 1<br />872 30 Kramfors</p>
            <SocialLinks>
              <SocialButton href="https://www.facebook.com/p/Lilla-flora-i-Kramfors-61564983360569/" target="_blank" rel="noopener noreferrer">
                📘 Facebook
              </SocialButton>
              <SocialButton href="https://www.instagram.com/lillaflorakramfors/" target="_blank" rel="noopener noreferrer">
                📷 Instagram
              </SocialButton>
            </SocialLinks>
          </FooterSection>
        </FooterContent>
        
        <FooterBottom>
          <p>&copy; 2024 Lillaflora. Alla rättigheter förbehållna.</p>
          <p>
            Drivs av{" "}
            <a href="https://bondenswebbyra.se">
              Bondenswebbyra
            </a>
          </p>
        </FooterBottom>
      </div>
    </FooterWrapper>
  );
};

export default Footer;
